import deleteBtn from "./../images/icon-delete.svg";
import img from "./../images/image-product-1-thumbnail.jpg";

function Cart(props) {
  return (
    <div className="cart-inner">
      <div className="cart-inner-header">
        <img alt="" src={img} className="cart-inner-thumbnail" />
        <div className="cart-inner-info">
          <p>Fall Limited Edition Sneakers</p>
          <p>
            $125 x {props.cartNumber}{" "}
            <span className="cart-inner-info-price">$375.00</span>
          </p>
        </div>
        <img alt="" src={deleteBtn} className="cart-inner-delete-btn" />
      </div>
      <button className="checkout">Checkout</button>
    </div>
  );
}

export default Cart;
